<template lang="pug"> 
  v-row(no-gutters)
    v-col(cols=12)
      v-data-table( 
        :headers="headerTrans"
        :items="items"
        :server-items-length="totalItem" 
        :loading="loading"
        :footer-props="footerProps"
        :hide-default-footer="true" 
        @click:row="$emit('click:row',$event)"
      )
        template(#no-data)
          n-empty 
        //- forward slot form parent to v-data-table
        template(
          v-for="key in templateKeys"
          v-slot:[key]="props" 
        )
          slot(
            :name="key"
            v-bind:item="props.item"
            v-bind:headers="props.headers"
            v-bind:value="props.value"
          ) 

        //- auto create datetime template
        template(
          v-for="key2 in templateDateTimeItems"
          v-slot:[key2]="{ value }"
        ) {{ value | dateFormat }}

        //- auto create currency template
        template(
          v-for="key3 in templateCurrencyItems"
          v-slot:[key3]="{ value }"
        ) {{ value | currency }}  

        //- auto create currencyAction template 
        template(
          v-for="key3 in templateCurrencyActionItems"
          v-slot:[key3]="{ value }"
        ) 
          b(
            v-if="value > 0" 
            :class="classColor(value)"
          ) +
          b(
            :class="classColor(value)"
          ) {{ value | currency }}  



    v-col(cols=12) 
      n-card-reporter(
        :items="items" 
        :headers="headerTrans"
        @click:row="$emit('click:row',$event)"
      ) 
        template(
          v-for="key in templateKeys"
          v-slot:[key]="props" 
        )
          slot(
            :name="key"
            v-bind:item="props.item"
            v-bind:headers="props.headers"
            v-bind:value="props.value"
          ) 
        //- auto create datetime template
        template(
          v-for="key2 in templateDateTimeItems"
          v-slot:[key2]="{ value }"
        ) {{ value | dateFormat }}

        //- auto create currency template
        template(
          v-for="key3 in templateCurrencyItems"
          v-slot:[key3]="{ value }"
        ) {{ value | currency }}  

        //- auto create currencyAction template
        template(
          v-for="key3 in templateCurrencyActionItems"
          v-slot:[key3]="{ value }"
        ) 
          b(
            v-if="value > 0" 
            :class="classColor(value)"
          ) +
          b(
            :class="classColor(value)"
          ) {{ value | currency }}  

      //- card empty 
      n-empty(
        v-if="items.length===0"
      ).bgEmpty

      n-pagination(
        v-if="meta && items.length !== 0"
        :meta="meta"
        :page="meta.current_page"
        @nextpage="$emit('nextpage', $event)" 
      )
</template>

<script>
export default {
  props: {
    headers: {
      type: Array,
      default: () => [],
    },

    items: {
      type: Array,
      default: () => []
    },

    meta: {
      type: Object,
      default: null
    },

    totalItem: {
      type: Number,
      default: -1
    }, 

    loading: {
      type: Boolean,
      default: false
    }
  },
  computed : {  
    headerTrans () {
      return this.headers.map(x=>{
        x.text = this.$t(x.text)
        return x
      })
    },
    footerProps () {
      return {
        'items-per-page-options': [15, 20, 50, 100],
        'items-per-page-text': this.$t('items-per-page-text'),
        'disablePagination': true
      }
    },
    templateKeys () {
      return Object.keys(this.$scopedSlots)
    },

    templateDateTimeItems () {
      return this.headers
        .filter(h => (h.format === 'dateFormat'))
        .map(h => (`item.${h.value}`))
    },

    templateCurrencyItems () {
      return this.headers
        .filter(h => (h.format === 'currency'))
        .map(h => (`item.${h.value}`))
    },

    templateCurrencyActionItems () {
      return this.headers
        .filter(h => (h.format === 'currencyAction'))
        .map(h => (`item.${h.value}`))
    },
  },
  methods:{
    classColor (val) {
      return val && parseFloat(val) > 0 ? 'green--text' : 'red--text'
    },  
  }
}
</script>
<style scoped >   
@media only screen and (max-width: 960px) {  
  .v-data-table {
    display: none !important;
  } 
  .bgEmpty { 
    display: flex !important;
    background-color: var(--bg-home);
  } 
}  
.bgEmpty {
  display: none;
} 
</style>